import { IAuthDataHandler } from '../../data-handlers/auth/IAuthDataHandler'
import { requestToken } from '../../firebase'
import SessionStorage from '../../services/storage/session-storage/SessionStorage'

export class AuthRepository {
    handler: IAuthDataHandler

    constructor(handler: IAuthDataHandler) {
        this.handler = handler
    }

    setAuth(token: string) {
        this.handler.setAuth(token)
    }

    async requestAuth(
        email: string,
        password: string
    ): Promise<{ token: string }> {
        const data = SessionStorage.get<IWebPushStored>('webPush')

        if (!data) {
            const token = await requestToken()
            console.log('token', token)
            SessionStorage.set('webPush', {
                token,
            })
            this.handler.setXToken(token)
        } else {
            const { token } = data
            this.handler.setXToken(token)
        }

        return this.handler.requestAuth(email, password)
    }
}

export interface IWebPushStored {
    token: string
}
